import request from '@/utils/request';

export const queryBlacklist = () => {
  return request.post('/manager/findBlackIP');
};

export const unblockIp = (ipId) => {
  return request.post('/manager/releaseIP?ipId=' + ipId);
};
